const cardLast4 = (cardNumber) => (`••••${(cardNumber || '').slice(-4)}`);

export { cardLast4 };
